// extracted by mini-css-extract-plugin
module.exports = {"loading":"_1j7xpDqi0qZNPai1neIJep"};